<template>
  <div class="monitor">
    <sub-title inner-text="" />
    <!-- 模型加载提示 -->
    <i
      :class="modelLoadIcon"
      style="position: fixed;right: 0;bottom: 0;z-index: 999;font-size: 1.5em;color: pink;vertical-align: middle;"
    />
    <!-- 头部 Start -->
    <div
      class="monitor-header"
    >
      <div style="position: absolute;left:0;margin: 5px 0px 0px 5px">
        <img
          style="height: 36px;width: auto"
          src="/images/screen/huagong/华工logo2.png"
        >
      </div>
      <!-- <screen-title :inner-text="screenTitle" /> -->
      <div class="monitor-header-title">
<!--        <img-->
<!--          style="height: 42px;width: auto; position: relative; top: 8px;"-->
<!--          src="/images/screen/huagong/华工logo1.png"-->
<!--        >-->
        <span class="top-title">
          {{ LWDW_TITLE_NAME }}
        </span>
        <!-- 只有当不是全屏模式时，才显示这个按钮 -->
        <div
          v-if="!isFullScreen"
          class="fullscreen-button-container"
        >
          <el-tooltip
            class="item"
            effect="dark"
            content="点击切换全屏"
            placement="bottom"
          >
            <el-button
              class="fullscreen-button"
              type="primary"
              icon="el-icon-full-screen"
              @click="goFullScreen"
            >
              切换全屏
            </el-button>
          </el-tooltip>
        </div>
      </div>
      <div style="display: flex; justify-content: flex-end;">
        <img
          v-show="!fireFlag && slxxId!==null"
          class="breathing-svg"
          src="/monitor/images/hj/火灾告警.svg"
          style="width: 63px; height: 73px;margin-top: 10px;position: absolute;right: 50px;user-select: none"
          @click="handleOpenHj()"
        >
      </div>
    </div>

    <!-- 头部 End -->

    <!-- 百度地图 start -->
    <b-map
      v-if="isBmap"
      ref="BMap"
      :dw-list="dwList"
      class="monitor-BMap"
      :capacity-name="this.currentUser.capacity.capacityCode"
    />
    <!-- 百度地图 End -->

    <!-- 中间背景 start -->
    <center-box
      v-if="!isBmap && !isTmap"
      ref="centerBox"
      :dw-list="dwList"
      class="monitor-BMap"
    />
    <!-- 中间背景 End -->
    <!-- 3维地图 start -->
    <t-map
      v-if="isTmap"
      ref="TMap"
      :dw-list="dwList"
      class="monitor-BMap"
    />
    <!-- 3维地图 End -->

    <!-- 语音对话 start -->
    <npl
      ref="Npl"
      class="monitor_npl-wrap o-zindex"
      :dw-list="dwList"
      :is-fire-warn="fireFlag && slxxId!==null"
    />
    <!-- 语音对话 end -->

    <!-- 演示介绍 start-->
    <!--    <introduce-->
    <!--      ref="Introduce"-->
    <!--      class="monitor_npl-wrap o-zindex"-->
    <!--    />-->
    <!-- 演示介绍 end-->

    <!-- 火灾报警 start -->
    <div v-if="hjxxList.length>0">
      <FireWarn
        v-show="fireFlag && slxxId"
        ref="FireWarn"
        :key="slxxId"
        class="monitor_fireWarn-wrap"
        :slxx-id="slxxId"
        :hjxx-list="hjxxList"
        @updateSlxxId="updateSlxxId"
        @handleCancleOme="handleCancleOme"
      />
    </div>
    <div
      class="o-flicker"
      :class="{
        'o-flicker--open': omeMusicStatus==='open'
      }"
    >
      <div
        v-if="fireAnimation"
        class="o-flicker__item o-flicker__item--top"
      />
      <div
        v-if="fireAnimation"
        class="o-flicker__item o-flicker__item--bottom"
      />
    </div>
    <audio
      id="bjs"
      ref="omeMusic"
      loop="loop"
      muted="muted"
      class="o-omen-audio"
      :src="$config.omenMusicSrc.warning"
    />
    <!-- 火灾报警 end -->

    <!-- 左侧图表 Start -->
    <transition
      appear
      :duration="{ enter: 1000, leave:1400 }"
      name="animate__animated animate__bounceInLeft"
      enter-active-class="animate__animated animate__bounceInLeft"
      leave-active-class="animate__animated animate__bounceOutLeft"
    >
      <chart-left-box
        v-show="isShow"
        :dw-list="dwList"
        :active-monitoring-room="activeJzwId"
        class="monitor_wrap monitor_wrap--left"
        :class="introduction.left.style"
      />
    </transition>
    <!-- 左侧图表 End -->

    <!-- 右侧图表 Start -->
    <transition
      appear
      :duration="{ enter: 1000, leave:1400 }"
      name="animate__animated animate__bounceInRight"
      enter-active-class="animate__animated animate__bounceInRight"
      leave-active-class="animate__animated animate__bounceOutRight"
    >
      <chart-right-box
        v-show="isShow && !showDetail"
        :dw-list="dwList"
        :active-monitoring-room="activeDwId"
        class="monitor_wrap monitor_wrap--right"
        :class="introduction.right.style"
      />
    </transition>
    <!-- 右侧图表 End -->

    <!-- 底部图表 Start -->
    <transition
      v-if="!showGzsbjl"
      appear
      :duration="{ enter: 1200, leave:2800 }"
      name="animate__animated animate__bounceInUp"
      enter-active-class="animate__animated animate__bounceInUp"
      leave-active-class="animate__animated animate__bounceOutDown"
    >
      <Jrfxsssj
        v-show="isShow && !showGzsbjl"
        :active-monitoring-room="activeDwId"
        :active-jzw="activeJzwId"
        class="monitor-bfooter"
        :class="introduction.bottom.style"
      />
    </transition>
    <transition
      v-if="showGzsbjl"
      appear
      :duration="{ enter: 1200, leave:2800 }"
      name="animate__animated animate__bounceInBottom"
      enter-active-class="animate__animated animate__bounceInBottom"
      leave-active-class="animate__animated animate__bounceOutBottom"
    >
      <chartGzsbBottom
        v-show="isShow && !showDetail && showGzsbjl"
        :active-monitoring-room="activeDwId"
        :active-jzw="activeJzwId"
        class="monitor-bfooter"
        :class="introduction.bottom.style"
      />
    </transition>
    <!-- 底部图表 End -->

    <!-- 顶部信息 Start -->
    <!-- 详情顶部不再展示 -->
    <transition
      appear
      :duration="{ enter: 1200, leave:2800 }"
      name="animate__animated animate__bounceInDown"
      enter-active-class="animate__animated animate__bounceInDown"
      leave-active-class="animate__animated animate__bounceOutUp"
    >
      <ChartDetailTopT
        v-show="isShow"
        :code="activeDwId"
        :jzw-id="activeJzwId"
        class="monitor-top"
        :class="introduction.top.style"
      />
    </transition>
    <!-- 顶部信息 End -->

    <!-- 左侧图表 Start -->
    <transition
      appear
      :duration="{ enter: 1000, leave:1400 }"
      name="animate__animated animate__bounceInLeft"
      enter-active-class="animate__animated animate__bounceInLeft"
      leave-active-class="animate__animated animate__bounceOutLeft"
    >
      <ChartDetailLeft
        v-if="false"
        :dw-list="dwList"
        :active-monitoring-room="activeDwId"
        class="monitor_wrap monitor_wrap--left"
        :class="introduction.left.style"
      />
    </transition>
    <!-- 左侧图表 End -->

    <!-- 右侧图表 Start -->
    <transition
      appear
      :duration="{ enter: 1000, leave:1400 }"
      name="animate__animated animate__bounceInRight"
      enter-active-class="animate__animated animate__bounceInRight"
      leave-active-class="animate__animated animate__bounceOutRight"
    >
      <ChartDetailRight
        v-show="isShow && showDetail"
        :code="activeDwId"
        :jzw-id="activeJzwId"
        class="monitor_wrap monitor_wrap--right"
        :class="introduction.right.style"
      />
    </transition>
    <!-- 右侧图表 End -->

    <!-- 底部信息 Start -->
    <transition
      appear
      :duration="{ enter: 1200, leave:2800 }"
      name="animate__animated animate__bounceInUp"
      enter-active-class="animate__animated animate__bounceInUp"
      leave-active-class="animate__animated animate__bounceOutDown"
    >
      <chartDetailBottom
        v-if="isShow && showDetail"
        :active-monitoring-room="activeDwId"
        :active-jzw="activeJzwId"
        class="monitor-bfooter"
        style="height: 290px"
        :class="introduction.bottom.style"
      />
    </transition>
    <!-- 底部信息 End -->

    <!-- 添加主机连接状态弹窗 -->
    <el-dialog
      title="主机连接状态"
      :visible.sync="zjxxDialogVisible"
      width="1000px"
      :before-close="handleCloseZjxxDialog"
      custom-class="zjxx-dialog"
      :show-close="false"
    >
      <img
        class="custom-close-icon"
        src="/images/newscreen/icon/close.png"
        @click="handleCloseZjxxDialog"
      >
      <zjxx-table
        v-if="zjxxDialogVisible"
        :lx="String(zjxxLx)"
        :jzw-id="jzwId"
      />
    </el-dialog>

<!--    显示消防栓信息-->t
<!--    <el-switch-->
<!--      v-model="showFireHydrant"-->
<!--      active-color="#13ce66"-->
<!--      inactive-color="#ff4949"-->
<!--      class="floating-button"-->
<!--      @change="changeShowFireHydrant()"-->
<!--      :active-text="showFireHydrant ? '隐藏消防栓' :'显示消防栓'">-->
<!--    </el-switch>-->

    <!-- 处理无线烟感状态弹窗 -->
    <el-dialog
      title="无线烟感状态"
      :visible.sync="wxygDialogVisible"
      width="1000px"
      :before-close="handleCloseWxygDialog"
      custom-class="wxyg-dialog"
      :show-close="false"
    >
      <img
        class="custom-close-icon"
        src="/images/newscreen/icon/close.png"
        @click="handleCloseWxygDialog"
      >
      <wxyg-table
        v-if="wxygDialogVisible"
        :lx="String(wxygLx)"
        :jzw-id="wxygJzwId"
      />
    </el-dialog>
  </div>
</template>

<script>
import TMap from './threeMap/ThreeMap.vue';
// import ScreenTitle from './components/ScreenTitle.vue';
import CenterBox from './components/centerBox.vue';
import BMap from './components/BMap.vue';
import Npl from '../virtual/npl/npl-index.vue';
import FireWarn from './fireWarn/fireWarnTJ.vue';
import ChartLeftBox from './components/leftBox-tj.vue';
import ChartRightBox from './components/rightBox.vue';
// import ChartDetailTop from './detail/topBox.vue';
import ChartDetailTopT from './detail/topBoxT.vue';
import ChartDetailLeft from './detail/leftBox.vue';
import ChartDetailRight from '../virtual/chart/rightBox.vue';
import chartDetailBottom from './detail/bottomBox.vue';
import chartGzsbBottom from './detail/bottomGzsbwx.vue';
import EventBus from './../../event-bus';
import { monitorService } from './monitor.service';
import SubTitle from './components/SubTitle.vue';
// import ChartBottomBox from './components/bottomBox.vue';
import Jrfxsssj from './components/jrfxsssj.vue';
import introduceJs from '@/features/introuduce/introduce.js';
// import introduce from '@/features/introuduce/index.vue';
import config from '@/config.js';
import { queryEnvDetail, getEnvInfo } from '@/features/feature.common.service';
// import webVideoCtrl from '@/features/introuduce/webVideoCtrl.js';
import ZjxxTable from './components/ZjxxTable.vue';
import WxygTable from './components/WxygTable.vue';

const { wsApi } = config.ctx;
export default {
  name: 'MonitorVue',
  components: {
    TMap,
    SubTitle,
    Jrfxsssj,
    // ScreenTitle,
    CenterBox,
    BMap,
    Npl,
    FireWarn,
    ChartLeftBox,
    ChartRightBox,
    // ChartDetailTop,
    ChartDetailLeft,
    ChartDetailRight,
    chartDetailBottom,
    chartGzsbBottom,
    ChartDetailTopT,
    ZjxxTable,
    WxygTable
    // ChartBottomBox,
  },
  data () {
    return {
      modelLoadIcon: 'el-icon-loading',
      screenTitle: '消防数字哨兵',
      fireFlag: true, // 火灾警报 控制显示或者隐藏火警页面
      isBmap: true,
      isTmap: true,
      num: 1,
      omeMusicStatus: 'close', // 警报声音开关
      showDetail: false, // 显示联网单位详情
      showGzsbjl: false, // 显示故障设备记录
      isShow: true, // 是否隐藏所有报表
      activeJzwId: null,
      // 单位数据
      activeDwId: null,
      dwList: [
      ],
      sbzt: null, // 今日设备状态
      slxxId: null, // 当前选择的火灾主键
      hjxxList: [], // 发生火灾的全部列表
      isFilterYxhjList: false, // 控制火警定时查询是否跳过筛选当前单位存在的火灾(包含未确认)  true:跳过查询  false:正常查询
      dwId: null,
      introduction: {
        left: {
          style: []
        },
        right: {
          style: []
        },
        lwzt: {
          style: []
        },
        bottom: {
          style: []
        },
        top: {
          style: []
        }
      },
      LWDW_TITLE_NAME: config.app.name,
      websocket: null,
      seesionId: null,
      ygtsFla: true,
      notifyPromise: Promise.resolve(),
      isFullScreen: false, // 初始化全屏状态为false
      checkFullScreenInterval: null, // 检查全屏状态的定时器
      apiMessage: '', // 接口状态信息返回结果 不会弹窗，会显示在左上角显示后会隐藏
      zjxxDialogVisible: false,
      zjxxLx: '1', // 使用字符串类型以匹配组件定义
      jzwId: null, // 使用字符串类型以匹配组件定义
      fireAnimation: true, // 控制是否显示火警动态效果
      showFireHydrant: true,
      fireHydrantInfos: [],
      sslxs: ['XF0508','XF0509','XF0510','XF0511','XF0512'],
      // 无线烟感弹窗相关数据
      wxygDialogVisible: false,
      wxygLx: '1',
      wxygJzwId: null
    };
  },
  computed: {
    // 用户信息
    currentUser () {
      return this.$HMStoreService.getUserinfo();
    }
  },
  methods: {
    async init () {
      const _this = this;
      await this.queryJqrjk();
      this.clock = setInterval(function () {
        _this.queryJqrjk();
      }, 1 * 60 * 1000);
      this.$refs.BMap.addMarkers(this.dwList);
      // 加载消防栓
      this.changeShowFireHydrant();
      this.xlry();
      this.queryHjxx();
      this.getEnvDetail();
      this.getEnvInfo();
      this.clock2 = setInterval(this.queryHjxx, 3 * 1000);
    },
    getEnvDetail () {
      queryEnvDetail().then(resp => {
        console.log(resp.data);
        resp.data.forEach(item => {
          // console.log('item', item);
          if (item.envId === 'SCREEN_HZ_IMG') {
            sessionStorage.setItem('SCREEN_HZ_IMG', item.envValue);
          }
        });
      });
    },
    getEnvInfo () {
      const ssdw = this.currentUser.capacity.deptCode;
      getEnvInfo(ssdw, 'LWDW_TITLE_NAME')
        .then(resp => {
          console.log(resp.data.envValue);
          this.LWDW_TITLE_NAME = resp.data.envValue;
        });
    },
    // 机器人监控室
    queryDqsbzt () {
      monitorService.queryDqsbzt().then(resp => {
        this.sbzt = resp.data;
      });
    },
    async queryJqrjk () {
      await monitorService.queryJqrjkByDwJzw().then(resp => {
        // monitorService.queryJqrjk().then(resp => {
        this.dwList = resp.data;
        // this.dwList.forEach(item => {
        //   // TODO 暂时写死坐标
        //   if (item.name.includes('物资大夏')) {
        //     item.lng = 113.285378; // 地理经度
        //     item.lat = 23.143544;// 地理纬度
        //   }
        //   if (item.name.includes('鸿蒙')) {
        //     item.lng = 113.375879; // 地理经度
        //     item.lat = 23.103363;// 地理纬度
        //   }
        // });
      }).catch(error => {
        if (error.response) {
          console.log('服务异常:', error.response);
        } else if (error.request) {
          console.log('网络异常:', error.request);
        } else {
          console.log('请求异常:', error.message);
        }
      });
    },
    changeDw (dwId) {
      const dw = this.dwList.find(el => el.code === dwId);
      if (this.isBmap) {
        this.$refs.BMap.changeDw(dw);
      } else if (this.isTmap) {
        this.$refs.TMap.changeDw(dw);
      } else {
        this.$refs.centerBox.changeDw(dw);
      }

      this.changeDetail(true, dwId);
    },
    changeJzw (dwId, jzwId) {
      const dw = this.dwList.find(el => el.code === jzwId);
      this.changeDetail(true, dwId, jzwId);
      if (this.isBmap) {
        this.$refs.BMap.changeDw(dw);
      } else if (this.isTmap) {
        this.$refs.TMap.changeDw(dw);
      } else {
        this.$refs.centerBox.changeDw(dw);
      }
    },
    changeDetail (flag, dwId, jzwId) {
      this.showDetail = flag;
      this.activeDwId = dwId;
      this.activeJzwId = jzwId;
    },
    /**
     * @description: 关闭报警声音
     * @return {*}
     */
    handleCancleOme (closeStatus = true, showMessage = false) {
      if (closeStatus) {
        this.omeMusicStatus = 'close';
      }
      this.$refs.omeMusic.pause();
      this.$refs.omeMusic.currentTime = 0.0;
      if (showMessage) {
        this.$message({
          message: '消音成功',
          type: 'success',
          duration: 1500
        });
      }
    },
    /**
     * @description: 开启声音报警
     * @return {*}
     */
    handleOpenOme () {
      const _this = this;
      const h = _this.$createElement;
      if (_this.omeMusicStatus === 'close') {
        // 开启
        _this.$refs.omeMusic.play().then(() => {
          // autoplay success
          _this.omeMusicStatus = 'open';
        }).catch(() => {
          _this.$alert('提示', {
            title: '提示',
            message: h('div', [
              h('p', '浏览器默认不允许播放音频，请前往配置以便后续默认支持音频播放，否则仅运行本次播放！'),
              h('a', { attrs: { class: 'u-text-primary u-pointer u-pd-t-4 u-inline-block', href: process.env.BASE_URL + 'omeSetIntro.html', target: '_blank' } }, '配置说明')
            ]),
            confirmButtonText: '本次允许',
            type: 'warning'
          })
            .then(() => {
              _this.$refs.omeMusic.play();
              _this.omeMusicStatus = 'open';
            }).catch(() => {
          });
        });
      } else {
        // 从头开始播放
        _this.$refs.omeMusic.currentTime = 0.0;
      }
    },
    handleOpenHj () {
      // 数字键4
      EventBus.$emit('controlShowHj', true, false);
    },
    handleOHj (dwId) {
      // this.isFilterYxhjList = true;
      this.dwId = dwId;
    },
    // 当前有效火警列表
    queryHjxx () {
      monitorService.getHjxx('').then(resp => {
        let hjxxList = resp.data;
        // console.log('=======查询所有火警情况========queryHjxx', hjxxList);
        // 如果火灾列表为空，则关闭声音
        if ((hjxxList && hjxxList.length === 0)) {
          this.handleCancleOme();
          this.slxxId = null;
          // 并且重置当前火列表
          this.hjxxList = [];
        }

        if (hjxxList && hjxxList.length > 0) {
          const zsHjxxList = [];

          hjxxList.forEach(item => {
            if (item.ssdw === this.dwId) {
              console.log('筛选danwei火灾', this.dwId);
              if ((item.xxqr === '2' && item.xnjqrbz === 'N') || (item.xnjqrbz === 'Y')) {
                // console.log('筛选真实火灾已确认火灾或虚拟机器人的火灾');
                zsHjxxList.push(item);
              }
            } else {
              if ((item.xxqr === '2' && item.xnjqrbz === 'N') || (item.xnjqrbz === 'Y')) {
                // console.log('筛选真实火灾已确认火灾或虚拟机器人的火灾');
                zsHjxxList.push(item);
              }
            }
          });
          hjxxList = zsHjxxList;
          // console.log('=========筛选后火灾list==========', zsHjxxList);
        }

        // 如果火灾列表为空，则关闭声音
        if ((hjxxList && hjxxList.length === 0)) {
          this.handleCancleOme();
          this.slxxId = null;
          // 并且重置当前火列表
          this.hjxxList = [];
        }

        // if (hjxxList && hjxxList.length > 0) {
        //   const zsHjxxList = [];
        //   console.log('是否筛选当前单位存在的火灾(包含未确认)==============', this.isFilterYxhjList);
        //   hjxxList.forEach(item => {
        //     // 单位监控列表里有火灾情况时，点击火灾图标，筛选出该单位的所有火灾情况(包含未确认)
        //     console.log('筛选当前单位存在的火灾(包含未确认)');
        //     if (this.isFilterYxhjList) {
        //       if (item.ssdw === this.dwId) {
        //         zsHjxxList.push(item);
        //       }
        //     } else {
        //       // 筛选真实火灾已确认火灾或虚拟机器人的火灾
        //       if ((item.xxqr === '2' && item.xnjqrbz === 'N') || (item.xnjqrbz === 'Y')) {
        //         console.log('筛选真实火灾已确认火灾或虚拟机器人的火灾');
        //         zsHjxxList.push(item);
        //       }
        //     }
        //   });
        //   console.log('=========筛选后火灾list==========', zsHjxxList);
        //   hjxxList = zsHjxxList;
        // }

        if (hjxxList && this.hjxxList.length !== hjxxList.length) {
          // 重置机器人监控室的单位列表
          this.queryJqrjk();
        }

        // 如果旧记录长度为0，并且新纪录长度大于0，则开启火灾并且播放声音
        if (this.hjxxList.length === 0 && hjxxList && hjxxList.length > 0) {
          // console.log('=========如果旧记录长度为0，并且新纪录长度大于0，则开启火灾并且播放声音==========', hjxxList);
          // 开启火灾并且播放声音
          EventBus.$emit('controlShowHj', true, true);
          this.slxxId = hjxxList[0].id;
        } else if (this.hjxxList.length > 0 && hjxxList && hjxxList.length > this.hjxxList.length) {
          // 如果新记录长度大于旧记录长度，且旧记录长度大于0，则自动跳转至火警界面
          this.slxxId = hjxxList[0].id;
          EventBus.$emit('controlShowHj', true, true);
        };

        // 刷新火灾列表，如果当前选择的火灾没在列表里面，则选择另外的最新火灾
        if (hjxxList && hjxxList.length > 0) {
          // console.log('=========刷新火灾列表，如果当前选择的火灾没在列表里面，则选择另外的最新火灾==========', hjxxList);
          this.hjxxList = hjxxList;
          // 设置最先的一条火警
          const slxxIdOld = this.slxxId;
          let lastHj = hjxxList.find(hj => hj.id === this.slxxId);
          const slxxId = lastHj ? lastHj.id : hjxxList[0].id;
          this.slxxId = slxxId;

          // 如果受理信息发生变化，则重置num
          if (slxxIdOld !== this.slxxId) {
            this.num = 1;
          }
          // 跳转疏散图
          lastHj = hjxxList.find(hj => hj.id === this.slxxId);
          if (lastHj.xxqr && lastHj.xxqr === '2' && this.num <= 1) {
            console.log('触发跳转疏散图', lastHj.xxqr);
            setTimeout(() => {
              EventBus.$emit('hj_qrhj');
            }, 2000);
            this.num = this.num + 1;
          }
        }
      }).catch(error => {
        if (error.response) {
          console.log('服务异常:', error.response);
        } else if (error.request) {
          console.log('网络异常:', error.request);
        } else {
          console.log('请求异常:', error.message);
        }
      });
    },
    updateSlxxId (slxxId) {
      console.log('更改当前火灾主键');
      this.slxxId = slxxId;
    },
    transformUint8ArrayToBase64 (array) {
      let binary = '';
      for (var len = array.byteLength, i = 0; i < len; i++) {
        binary += String.fromCharCode(array[i]);
      }
      return window.btoa(binary).replace(/=/g, '');
    },
    randomSessionId () {
      const ua = new Uint8Array(20);
      new DataView(ua.buffer).setUint32(0, Math.floor(+new Date() / 1000));
      const crypto = window.crypto || window.msCrypto;
      if (crypto) {
        crypto.getRandomValues(ua.subarray(4, 20));
      }
      return (
        this.transformUint8ArrayToBase64(ua)
          .replace(/\+/g, '-')
          .replace(/\//g, '-')
      );
    },

    websocketInit () {
      const hasToken = this.$HMCookies.get(config.localTokenName) || false;
      const _this = this;
      if (hasToken) {
        const wsprocotol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
        let apiContext = '';
        if (!wsApi) {
          apiContext = '/api/iff';
        }

        console.log(`${wsprocotol}${wsApi || window.location.host}${apiContext}/iff/socket/ssjk/`);
        this.websocket = new WebSocket(`${wsprocotol}${wsApi || window.location.host}${apiContext}/iff/socket/ssjk/${this.seesionId}?token=${hasToken}`);
        // this.websocket = new WebSocket(`ws://localhost:18070/iff/iff/socket/ssjk/${this.seesionId}?token=${hasToken}`);
        // this.websocket = new WebSocket(`wss://iff-rpa-test.hongmeng.cloud/api/iff/iff/socket/ssjk/${this.seesionId}?token=${hasToken}`);
        this.websocket.onopen = () => {
          _this.socketOpen = true;
          console.log('Socket连接成功');
          this.websocket.send(JSON.stringify({ layout: 'Dplayout' }));
        };
        this.websocket.onmessage = (res) => {
          const resdata = JSON.parse(res.data);
          if (resdata.key === 'cgcfts') {
            this.cgcfts(resdata.values);
          } else if (resdata.key === 'ygcs') {
            this.ygcs(resdata.values);
          } else if (resdata.key === 'ygts') {
            this.ygtsFla = resdata.values.id !== sessionStorage.getItem(resdata.values.ssdw);
            if (resdata.values !== null && this.ygtsFla) {
              this.ygts(resdata.values);
            }
          }
        };
        this.websocket.onerror = () => {
          _this.socketOpen = false;
          console.log('Socket连接发生错误，将在5秒后重试...');
          setTimeout(() => {
            if (!this.socketOpen) {
              _this.socketOpen = true;
              this.websocketInit();
            }
          }, 5000);
        };
        this.websocket.onclose = () => {
          _this.socketOpen = false;
          console.log('Socket连接已关闭，将在5秒后重试...');
          setTimeout(() => {
            if (!this.socketOpen) {
              _this.socketOpen = true;
              this.websocketInit();
            }
          }, 5000);
        };
      }
    },
    // 单位查岗
    handleCg (_ssdw) {
      const dwmc = this.dwList.filter(item => item.botid === _ssdw);
      console.log(dwmc);
      this.$message({
        showClose: true,
        duration: 3000,
        type: 'success',
        message: '已对【' + dwmc[0].name + '】发起查岗！'
      });
      this.websocket.send(JSON.stringify({ cg: { id: _ssdw, code: _ssdw } }));
    },

    /**
     * 所有单位查岗
     */
    handleAllCg () {
      console.log('发起全部查岗');
      this.$message({
        showClose: true,
        duration: 3000,
        type: 'success',
        message: '已对所有在线单位发起查岗！'
      });
      this.websocket.send(JSON.stringify({ allcg: { code: 'code' } }));
    },
    /**
     * 查岗重复提示
     */
    cgcfts (_item) {
      const canter = '(' + _item.ssdwMc + ') 单位已查岗,待应岗中!,发起人：' + _item.fqrMc + ',查岗时间：' + _item.fqsjStr;
      this.$message({
        showClose: true,
        duration: 5000,
        message: canter
      });
    },

    /**
     * 应岗提醒
     */
    ygts (_item) {
      console.log(_item);
      sessionStorage.setItem(_item.ssdw, _item.id);
      const canter = '单位应岗成功!,当前值班人员：' + _item.zbrymc;
      this.notifyPromise = this.notifyPromise.then(() => {
        this.$notify({
          title: _item.ssdwMc + '(应岗成功)!',
          type: 'success',
          message: canter,
          position: 'bottom-right',
          duration: 10000,
          offset: 150
        });
      });
    },
    ygcs (_item) {
      this.warining(this.$refs.cgcsMusic);
      const canter = '请注意该单位查岗时间点(' + _item.fqsjStr + ') 未应岗,当前值班人员/联系电话:' + _item.zbrymc + '/' + _item.lxdh;
      this.notifyPromise = this.notifyPromise.then(() => {
        this.$notify({
          title: _item.ssdwMc + '(应岗超时)!',
          type: 'warning',
          message: canter,
          position: 'bottom-right',
          offset: 150,
          duration: 1000 * 60 * 1,
          onClose: action => {
            this.cancelWarning(this.$refs.cgcsMusic);
          }
        });
      });
    },
    // 打开全屏
    goFullScreen () {
      const element = document.documentElement;

      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) { /* Firefox */
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) { /* IE/Edge */
        element.msRequestFullscreen();
      }
    },
    checkFullScreen () {
      // 检查窗口尺寸是否与屏幕尺寸相匹配
      this.isFullScreen = window.innerHeight === screen.height;
    },
    showApiMessage (message) {
      this.apiMessage = message;
      const newestShowTime = new Date().getTime();
      setTimeout(() => {
        // 当前时间没有大于3秒，则不清空
        if (new Date().getTime() - newestShowTime < 3000) {
          return;
        }
        this.apiMessage = '';
      }, 3000);
    },
    // 处理主机状态弹窗
    handleShowZjxxDialog (lx) {
      this.zjxxLx = lx.lx;
      this.jzwId = lx.jzwId;
      this.zjxxDialogVisible = true;
    },
    handleCloseZjxxDialog () {
      this.zjxxDialogVisible = false;
    },
    // 处理无线烟感状态弹窗
    handleShowWxygDialog (params) {
      this.wxygLx = params.lx;
      this.wxygJzwId = params.jzwId;
      this.wxygDialogVisible = true;
    },
    handleCloseWxygDialog () {
      this.wxygDialogVisible = false;
    },
    // 获取变量判断是否要展示火警的动态效果
    queryWarnAnimation () {
      monitorService
        .queryEnvInfo('101', 'HM_FIRE_ANIMATION')
        .then(rsp => {
          const data = rsp.data;
          if (data && data.envValue === 'FALSE') {
            this.fireAnimation = false;
          }
        })
        .catch(err => {
          console.error('获取环境变量信息错误！', err);
        })
        .finally(() => {
        });
    },
    changeShowFireHydrant(){
      if (this.showFireHydrant) {
        const params={
          ssdw:this.activeDwId,
          sslxs: this.sslxs
        }
        monitorService.queryJtzcBySslxs(params).then(resp => {
          this.fireHydrantInfos = resp.data;
          this.$refs.BMap.addMarkersWithOutName(this.fireHydrantInfos);
        }).catch(error => {
            console.log('请求异常:', error.message);
        });
      } else {
        this.$refs.BMap.cleanFireHydrant();
      }
    },
    xlry(){
      const params = [
        { id: null, zcbh: 'XF050819', ld: '1', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '费林', azwz: '15308135703', dzLng: '8495435.429825647', dzLat: '2775881.309498613', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '2', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '王保春', azwz: '13128267845', dzLng: '8494586.467630757', dzLat: '2776006.740971958', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '3', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '王小艳', azwz: '18824161958', dzLng: '8494806.0945774', dzLat: '2775867.588021032', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '4', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '向忠才', azwz: '13798149379', dzLng: '8495084.400479252', dzLat: '2775731.788153261', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '5', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '肖坤红', azwz: '15982904997', dzLng: '8495173.257182855', dzLat: '2775538.9858718575', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '6', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '谢传举', azwz: '18218342315', dzLng: '8494593.173797067', dzLat: '2775768.6720679644', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '7', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '徐金志', azwz: '18666096387', dzLng: '8495568.089299584', dzLat: '2775581.320552881', imgUrl: '/assets/巡逻人.svg' },

        { id: null, zcbh: 'XF050819', ld: '厉吾楼', ssdw: 'CLOUD_DEMO1000008900', title: '值班员', gw: '值班员', bjmc: '邓春华', azwz: '1371002621', dzLng: '8495204.79095752', dzLat: '2775894.8318216642', imgUrl: '/assets/值班人.svg' },
        { id: null, zcbh: 'XF050819', ld: '计算中心', ssdw: 'CLOUD_DEMO1000008900', title: '值班员', gw: '值班员', bjmc: '邓洪友', azwz: '18520341158', dzLng: '8494683.3045404600', dzLat: '2776018.9411805100', imgUrl: '/assets/值班人.svg' },
        { id: null, zcbh: 'XF050819', ld: '逸夫科学馆', ssdw: 'CLOUD_DEMO1000008900', title: '值班员', gw: '值班员', bjmc: '邓丽琴', azwz: '15303061875', dzLng: '8494754.3342356100', dzLat: '2775726.6196095400', imgUrl: '/assets/值班人.svg' },
        { id: null, zcbh: 'XF050819', ld: '29号楼', ssdw: 'CLOUD_DEMO1000008900', title: '值班员', gw: '值班员', bjmc: '邓丽雅', azwz: '15217615339', dzLng: '8494970.8663633000', dzLat: '2776081.8891025500', imgUrl: '/assets/值班人.svg' },
        { id: null, zcbh: 'XF050819', ld: '8号楼', ssdw: 'CLOUD_DEMO1000008900', title: '值班员', gw: '值班员', bjmc: '邓伟丽', azwz: '15727197793', dzLng: '8494894.8541431300', dzLat: '2775940.5709559800', imgUrl: '/assets/值班人.svg' },
        { id: null, zcbh: 'XF050819', ld: '7号楼', ssdw: 'CLOUD_DEMO1000008900', title: '值班员', gw: '值班员', bjmc: '刘亚平', azwz: '13033183319', dzLng: '8495483.3202368200', dzLat: '2775746.5112683900', imgUrl: '/assets/值班人.svg' },
        { id: null, zcbh: 'XF050819', ld: '20号楼', ssdw: 'CLOUD_DEMO1000008900', title: '值班员', gw: '值班员', bjmc: '刘用兰', azwz: '15917453098', dzLng: '8495407.4959759200', dzLat: '2775972.7466216800', imgUrl: '/assets/值班人.svg' },

        { id: null, zcbh: 'XF050819', ld: '厉吾楼', ssdw: 'CLOUD_DEMO1000008900', title: '楼管理员', gw: '楼栋负责人', bjmc: '方宝林', azwz: '13128214819', dzLng: '8495247.657168975', dzLat: '2775939.9884538227', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '计算中心', ssdw: 'CLOUD_DEMO1000008900', title: '楼管理员', gw: '楼栋负责人', bjmc: '封瑞', azwz: '13922370867', dzLng: '8494783.3045404600', dzLat: '2776018.9411805100', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '逸夫科学馆', ssdw: 'CLOUD_DEMO1000008900', title: '楼管理员', gw: '楼栋负责人', bjmc: '甘玉霞', azwz: '18771807117', dzLng: '8494854.3342356100', dzLat: '2775726.6196095400', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '29号楼', ssdw: 'CLOUD_DEMO1000008900', title: '楼管理员', gw: '楼栋负责人', bjmc: '黄昭惠', azwz: '13723816907', dzLng: '8495060.8663633000', dzLat: '2776081.8891025500', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '8号楼', ssdw: 'CLOUD_DEMO1000008900', title: '楼管理员', gw: '楼栋负责人', bjmc: '江凡', azwz: '18202095408', dzLng: '8494994.8541431300', dzLat: '2775940.5709559800', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '电力实验楼', ssdw: 'CLOUD_DEMO1000008900', title: '楼管理员', gw: '楼栋负责人', bjmc: '廖浩文', azwz: '18024863002', dzLng: '8494677.3242258500', dzLat: '2776130.6072509500', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '小黄楼', ssdw: 'CLOUD_DEMO1000008900', title: '楼管理员', gw: '楼栋负责人', bjmc: '李茂生', azwz: '15013374632', dzLng: '8494779.8388348700', dzLat: '2776098.6042494700', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '7号楼', ssdw: 'CLOUD_DEMO1000008900', title: '楼管理员', gw: '楼栋负责人', bjmc: '刘文娟', azwz: '13632465340', dzLng: '8495583.3202368200', dzLat: '2775746.5112683900', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '20号楼', ssdw: 'CLOUD_DEMO1000008900', title: '楼管理员', gw: '楼栋负责人', bjmc: '罗桂容', azwz: '18344453091', dzLng: '8495367.4959759200', dzLat: '2775932.7466216800', imgUrl: '/assets/管理人.svg' },


        { id: null, zcbh: 'XF050819', ld: '17', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '邓春华', azwz: '1371002621', dzLng: '8495123.698557146', dzLat: '2779296.8584751072', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '14', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '邓洪友', azwz: '18520341158', dzLng: '8495267.881132804', dzLat: '2778995.0809911713', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '19', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '邓丽琴', azwz: '15303061875', dzLng: '8495479.12537156', dzLat: '2778606.1233452098', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '20', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '邓丽雅', azwz: '15217615339', dzLng: '8495713.841192398', dzLat: '2779001.787157481', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '24', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '邓伟丽', azwz: '15727197793', dzLng: '8495432.182207393', dzLat: '2779367.273221359', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '11', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '方宝林', azwz: '13128214819', dzLng: '8494543.615171358', dzLat: '2778431.7630211576', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '15', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '费林', azwz: '15308135703', dzLng: '8494553.674420822', dzLat: '2779145.9697331395', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '12', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '封瑞', azwz: '13922370867', dzLng: '8494563.733670287', dzLat: '2778790.542918726', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '16', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '甘玉霞', azwz: '18771807117', dzLng: '8494798.449491126', dzLat: '2779273.3868930233', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '13', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '黄昭惠', azwz: '13723816907', dzLng: '8494939.27898363', dzLat: '2778750.3059208677', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '18', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '江凡', azwz: '18202095408', dzLng: '8495063.34306036', dzLat: '2778478.7061853255', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '21', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '廖浩文', azwz: '18024863002', dzLng: '8494563.733670287', dzLat: '2779538.280462256', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '22', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '李茂生', azwz: '15013374632', dzLng: '8494215.013022184', dzLat: '2779122.4981510555', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '23', ssdw: 'CLOUD_DEMO1000008900', title: '校园安保', gw: '校园安保', bjmc: '刘文娟', azwz: '13033183319', dzLng: '8494771.624825887', dzLat: '2779025.258739565', imgUrl: '/assets/巡逻人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区幼儿园', ssdw: 'CLOUD_DEMO1000008900', title: '值班员', gw: '值班员', bjmc: '刘亚平', azwz: '13632465340', dzLng: '8495126.6757241400', dzLat: '2778648.1308632600', imgUrl: '/assets/值班人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北一宿舍', ssdw: 'CLOUD_DEMO1000008900', title: '值班员', gw: '值班员', bjmc: '刘用兰', azwz: '15917453098', dzLng: '8494503.2153788600', dzLat: '2779305.3825045900', imgUrl: '/assets/值班人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区幼儿园', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '罗桂容', azwz: '18344453091', dzLng: '8495026.6757241400', dzLat: '2778648.1308632600', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北一宿舍', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '罗密', azwz: '17688825906', dzLng: '8494403.2153788600', dzLat: '2779305.3825045900', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区宿舍10号楼', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '马云', azwz: '15013320190', dzLng: '8494434.5773999500', dzLat: '2779031.6693951800', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区宿舍11号楼', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '丘鑫敦', azwz: '13660211139', dzLng: '8494344.4632901700', dzLat: '2778889.5420979000', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区宿舍12号楼', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '王保春', azwz: '13128267845', dzLng: '8494654.6234819900', dzLat: '2778851.8199124100', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区宿舍13号楼', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '王小艳', azwz: '18824161958', dzLng: '8494596.9923652700', dzLat: '2778676.8308852700', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区宿舍14号楼', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '向忠才', azwz: '13798149379', dzLng: '8494449.5626040000', dzLat: '2778564.2123156600', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区宿舍15号楼', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '肖坤红', azwz: '15982904997', dzLng: '8494277.7170923100', dzLat: '2778509.7247143900', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区宿舍16号楼', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '谢传举', azwz: '18218342315', dzLng: '8494146.7372815800', dzLat: '2778445.8065667500', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区宿舍2号楼', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '徐金志', azwz: '18666096387', dzLng: '8494737.9649553200', dzLat: '2779457.2646161100', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区宿舍3号楼', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '徐明昌', azwz: '13268379396', dzLng: '8494904.5712745700', dzLat: '2779302.1845202000', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区宿舍4号楼', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '殷才秀', azwz: '18228669232', dzLng: '8495193.7746966800', dzLat: '2779131.3868470000', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区宿舍6号楼', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '袁升香', azwz: '18218354492', dzLng: '8495192.2751655000', dzLat: '2779211.1853584500', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区宿舍8号楼', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '张莉', azwz: '13428867615', dzLng: '8494331.8892283400', dzLat: '2779205.6105838400', imgUrl: '/assets/管理人.svg' },
        { id: null, zcbh: 'XF050819', ld: '北区宿舍9号楼', ssdw: 'CLOUD_DEMO1000008900', title: '宿舍管理员', gw: '楼栋负责人', bjmc: '钟伟良', azwz: '13527873089', dzLng: '8494207.1964485100', dzLat: '2779069.3915806700', imgUrl: '/assets/管理人.svg' },

      ];

      this.$refs.BMap.addxlry(params);
    }
  },
  watch: {
    slxxId (val) {
      console.log('slxxId被触发修改', val);
      if (val) {
        this.$refs.Introduce.introduceAll = false;
      }
    }
  },
  mounted () {
    this.seesionId = this.randomSessionId();
    window.addEventListener('beforeunload', function (event) {
      console.log('页面刷新清除cad缓存文件');
      // 清除key 为CAD_URL:开头的数据
      for (const key in sessionStorage) {
        if (key.indexOf('CAD_URL:') === 0) {
          sessionStorage.removeItem(key);
        }
      }
    });
    this.websocketInit();
    // 切换不同版本
    this.isBmap = this.$route.query.isBmap !== 'false';
    this.isTmap = this.$route.query.isTmap === 'true';

    this.init();
    // 增加快捷键设置y
    document.addEventListener('keypress', (event) => {
      if (event.shiftKey && event.code === 'Digit1') {
        // 数字键1
        this.isShow = !this.isShow;
      }
      if (event.shiftKey && event.code === 'Digit1') {
        this.$refs.Npl.resetNpl();
      }

      if (event.shiftKey && event.code === 'Digit2') {
        // 数字键2
        this.$refs.Npl.listen();
      }
      if (event.shiftKey && event.code === 'Digit3') {
        // 数字键3
        this.$refs.Npl.change();
      }
      if (event.shiftKey && event.code === 'Digit4') {
        // 数字键4
        EventBus.$emit('controlShowHj', !this.fireFlag);
      }
    });

    // 监听EventBus触发事件
    /* 调用方式：
      1、 EventBus.$emit('nplListen', params);
      2、window.EventBus.$emit('nplListen', params);
    */
    EventBus.$on('nplListen', param => {
      console.log('EventBus事件触发，入参：', param);
      this.$refs.Npl.listen();
    });

    EventBus.$on('ModelLoaded', param => {
      console.log(param);
      this.modelLoadIcon = param === true ? 'el-icon-check' : 'el-icon-close';
    });

    EventBus.$on('Dpdwcg', ssdw => {
      console.log(ssdw);
      this.handleCg(ssdw);
    });
    EventBus.$on('DpYjcg', data => {
      this.handleAllCg();
    });

    EventBus.$on('DpGzsbjl', data => {
      this.showGzsbjl = !this.showGzsbjl;
    });

    EventBus.$on('apiMessage', data => {
      this.showApiMessage(data);
    });

    // 隐藏火警
    EventBus.$on('controlShowHj', (param, controlOme = false) => {
      // pram: true 显示火警
      this.fireFlag = param;
      // 控制声音
      if (this.fireFlag && controlOme) {
        this.handleOpenOme();
      } else if (!this.fireFlag && controlOme) {
        this.handleCancleOme();
      }
    });

    // 监听主机状态弹窗事件
    EventBus.$on('showZjxxDialog', (params) => {
      this.handleShowZjxxDialog(params);
    });

    // 监听无线烟感状态弹窗事件
    EventBus.$on('showWxygDialog', (params) => {
      this.handleShowWxygDialog(params);
    });

    const that = this;
    EventBus.$on('MapEmitEvent', param => {
      that.changeJzw(param.botid, param.code);
    });
  },
  created () {
    const _this = this;

    console.log('当前用户信息', this.currentUser.id);
    sessionStorage.setItem('loginUser', this.currentUser.id);
    EventBus.$on('introduce_zt_start', function (data) {
      console.log('introduce_zt_start');

      introduceJs.activeElement(_this.introduction, data, EventBus);
      console.log(_this.introduction);
    });
    EventBus.$on('introduce_zt_stop', function (data) {
      introduceJs.clearStyle(_this.introduction, EventBus);
    });

    // 监听火灾
    EventBus.$on('hzInfo', function (hjxxList) {
      if (hjxxList && hjxxList.length > 0) {
        // const slxxId = hjxxList[0].id;
        // if (!_this.slxxId) _this.handleOpenOme();
        // _this.slxxId = slxxId;
      } else {
        _this.slxxId = null;
        _this.handleCancleOme();
      }
    });

    this.checkFullScreen(); // 检查初始全屏状态
    this.checkFullScreenInterval = setInterval(this.checkFullScreen, 500); // 每检查一次

    // 判断是否进行屏蔽火灾的动态效果
    this.queryWarnAnimation();
  },

  destroyed () {
    clearInterval(this.clock);
    clearInterval(this.clock2);
    this.websocket.close();

    clearInterval(this.checkFullScreenInterval); // 清除定时器
  }
};
</script>

<style scoped lang="scss">
@import '../introuduce/introduce.css';

$--header-h: 70px;
$--header-h2: 190px;
$--chart-left-w: 360px; // 21.7%
$--chart-right-w: 399px; // 25.3%
$--bottom-w: 1087px;

.monitor{
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: auto;
}

.monitor-header{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 14;
  width: 100%;
  height: 100px;
  text-align: center;
  background: url('/images/newscreen/bg/大标题.png') no-repeat center center;
  background-size: cover;

  display: flex;
  justify-content: center;
  /* &::before{
    content: "";
    display: inline-block;
    width: 468px;
    height: 40px;
    background: url('/images/screen/title.svg') no-repeat center center;
  } */
}

.monitor-BMap{
  width: 100%;
  height: 100%;
  margin: 0 auto;
}

.monitor_npl-wrap{
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;

  &.o-zindex{
    top: $--header-h;
    z-index: 1114;
  }

}

.monitor_fireWarn-wrap{
  position: absolute;
  top: $--header-h;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1200;
}

.monitor_wrap{
  position: absolute;
  z-index: 1112;
  box-sizing: border-box;
  width: 362px;
  height: 970px;
  overflow: hidden;
  // padding: 28px 20px 28px 14px;
  color: #fff;
  background: url('/images/newscreen/bg/建筑监控室.png') no-repeat 0 0 / cover;

  &--left{
    top: $--header-h + 15px;
    bottom: 0;
    left: 18px;
    width: $--chart-left-w;
  }

  &--right{
    top: $--header-h + 15px;
    right: 18px;
    bottom: 0;
    width: $--chart-right-w - 16px;
  }
}

.monitor-top{
  position: absolute;
  justify-content: center;
  gap: 6px;
  top: $--header-h + -1px;
  left: $--chart-left-w + 22;
  z-index: 14;
  box-sizing: border-box;
  width: 1130px;
}

.monitor-bfooter {
  position: absolute;
  bottom: 30px;
  left: $--chart-left-w + 45;
  z-index: 14;
  box-sizing: border-box;
  width: $--bottom-w;
  color: #fff;
}

.top-title {
  font-family: MicrosoftYaHei;
  font-size: 42px;
  color: #00FCFF;
  letter-spacing: 4px;
  text-align: center;
  font-weight: 400;
}

@keyframes redPulse {
  from {
    box-shadow: 0 0 40px 20px #d84f28;
    background-color: #d84f28;
  }

  25% {
    box-shadow: 0 0 90px 40px #e0461b;
    background-color: #e0461b;
  }

  50% {
    box-shadow: 0 0 140px 60px #e33100;;
    background-color: #e33100;
  }

  75% {
    box-shadow: 0 0 90px 40px #e0461b;
    background-color: #e0461b;
  }

  to {
    box-shadow: 0 0 40px 20px #d84f28;
    background-color: #d84f28;
  }
}

.o-flicker__item{
  display: none;
  position: absolute;
  right: 0;
  left: 0;
  z-index: 9999;
  height: 0;

  &--top{
    top: 0;
  }

  &--bottom{
    bottom: -20px;
  }
}

.o-flicker--open .o-flicker__item{
  display: block;
  animation: redPulse 2.5s infinite;
}

.npl-wrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  width: 1920px;
}

.monitor-header-title{
  width: 520px;
  height: 43px;
  font-family: HYYaKuHei-85J;
  font-weight: 85J;
  font-size: 36px;
  color: #00FCFF;
  letter-spacing: 5.4px;
  text-align: center;
  margin-top: 20px;
  user-select: none;
}
.breathing-svg {
  width: 36px;
  height: 36px;
  margin-top: 6px;
  position: absolute;
  right: 20px;
  user-select: none;
  animation: breathing 1s infinite alternate;
}
@keyframes breathing {
  0% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.fullscreen-button {
  position: relative;
  left: 0px;
  top: -75px;
  background-color: transparent !important; /* 设置背景为透明 */
  border: none !important; /* 移除边框 */
  color: #fff; /* 设置文字颜色，根据需要自行调整 */
}

.fullscreen-button:hover {
  /* 鼠标悬停的样式效果 */
  transform: scale(1.1); /* 使按钮稍微放大 */
  transition: transform 0.3s ease-in-out;
}

/* 自定义关闭按钮样式 */
.custom-close-icon {
  position: absolute;
  top: 20px;
  right: 40px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  z-index: 10;
}

/* 覆盖弹窗整体背景和边框 */
:deep(.zjxx-dialog) {
  height: 620px;
  background: url('/images/newscreen/bg/弹框.png') no-repeat center center;
  background-size: 100% 100%;
  border: none; /* 移除默认边框 */
  border-radius: 8px; /* 可选：圆角 */
  .el-dialog__header {
    background: transparent; /* 透明标题栏 */
    border-bottom: none; /* 移除标题下边框 */
    padding: 20px;
    .el-dialog__title {
      font-family: MicrosoftYaHei;
      font-size: 18px;
      color: #FFFFFF;
      letter-spacing: 0;
      font-weight: 400;
      margin-left: 10px;
    }
  }
  .el-dialog__body {
    background: transparent; /* 透明内容区 */
    padding: 20px;
    height: calc(100% - 80px); /* 减去header高度 */
    overflow: hidden;
  }
}

.floating-button {
  position: fixed;     /* 固定定位，相对于视口 */
  bottom: 750px;        /* 距离底部距离 */
  right: 422px;         /* 距离右侧距离 */
  cursor: pointer;     /* 鼠标样式为指针 */
  color: red;
  z-index: 1000;       /* 确保按钮在其他元素上面 */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 10px 10px 10px;
}

::v-deep .el-switch__label{
  color: white !important;
}

/* 无线烟感弹窗样式 */
:deep(.wxyg-dialog) {
  height: 620px;
  background: url('/images/newscreen/bg/弹框.png') no-repeat center center;
  background-size: 100% 100%;
  border: none;
  border-radius: 8px;
  .el-dialog__header {
    background: transparent;
    border-bottom: none;
    padding: 20px;
    .el-dialog__title {
      font-family: MicrosoftYaHei;
      font-size: 18px;
      color: #FFFFFF;
      letter-spacing: 0;
      font-weight: 400;
      margin-left: 10px;
    }
  }
  .el-dialog__body {
    background: transparent;
    padding: 20px;
    height: calc(100% - 80px); /* 减去header高度 */
    overflow: hidden;
  }
}
</style>
